
const ADDRESS_KEY = /address/i;

const EMAIL_ANYWHERE = /[^\s@]+@[^\s@]+\.[a-zA-Z]{2,}/;

export function isAddressField(optionKey: string | undefined): boolean {
  return optionKey ? ADDRESS_KEY.test(optionKey) : false;
}

export function containsEmail(value: string | undefined): boolean {
  return value ? EMAIL_ANYWHERE.test(value) : false;
}
